import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";

import usePagination from "../../../../hooks/usePagination";
import { COMPLIANCE_API_URLS, ComplianceAPI } from "../../../../api/compliance";
import { appendSearchParamsToQuery } from "../../../ComplianceSearch/utils";
import { fundedComplianceProfileActions } from "../../../../reducers/fundedComplianceProfile";
import { Table } from "../../../../components/ui";
import { FAILED_COLUMNS } from "../../../ComplianceSearch/components/HeliosFailedSearch/constants";
const Failed: React.FC = () => {
  const dispatch = useDispatch();
  const params: { id: string } = useParams();
  const search = { compliance_entries_id: params.id };

  const { data, isLoading } = useSelector((state) => state.fundedComplianceProfile.failed);

  const pagination = usePagination(10);

  const { isError, error } = useQuery({
    queryKey: [COMPLIANCE_API_URLS.getFailed, params.id, pagination.page, pagination.limit],
    async queryFn({ signal }) {
      const query = new URLSearchParams();
      query.append("limit", pagination.limit.toString());
      query.append("page", pagination.page.toString());
      appendSearchParamsToQuery(search, query);

      dispatch(fundedComplianceProfileActions.fetchFailedRequest());
      const { data } = await ComplianceAPI.getWatchlistFailedRequest(query.toString(), signal);
      pagination.setCount(data.results.count);
      dispatch(fundedComplianceProfileActions.fetchFailedSuccess(data.results));

      return data;
    },
  });

  useEffect(() => {
    if (isError && error) {
      console.error("Error fetching Failed", error);
      dispatch(fundedComplianceProfileActions.fetchFailedFailed());
    }
  }, [isError, error]);

  return (
    <Table
      columns={FAILED_COLUMNS}
      data={data.rows}
      loading={isLoading}
      pagination={pagination}
      extractKey={(row) => row.id}
      theadTitle="Failed"
      csv_table_name={`Failed entry ID: ${params.id}`}
      noResultsMessage="There are no failed records"
    />
  );
};

export default Failed;
